module.exports = __webpack_public_path__ + "img/zaluzie.d699852b.svg";